import React from 'react';
import {Navigate} from 'react-router-dom';

import PageContent from '../../../../../components/PageContent/PageContent';
import Tabs from '../../../../../components/Tabs/Tabs';
import {allRoutes} from '../../../../../constants/Routes';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';

// import EmployeeDetails from './employeeDetails/EmployeeDetails';

const UserManagement: React.FC = () => {
  const orgFac = [
    // {
    //   id: 'empData',
    //   name: <TranslatedText translationKey="Employee Details" />,
    //   component: <EmployeeDetails />
    // },
    {
      id: 'userRolesAndPermissions',
      name: <TranslatedText translationKey="User Roles and Permissions" />,
      component: <Navigate to={allRoutes.Configurator.userManager} />
    }
  ];

  return (
    <PageContent>
      <Tabs array={orgFac} noPadding />
    </PageContent>
  );
};

export default UserManagement;
